/**
 * @generated SignedSource<<00909ee5a989ba001da481898bb32165>>
 * @relayHash f4f953e9b3e43aca0f1942ace4d4c3d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3e4fb5a76528efa6596b16d5826ad1ed69896b72b44f6b7da2c1b94eab846734

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraCFOSortOrder = "ASC" | "DESC" | "%future added value";
export type JiraCFOTimeGranularity = "DAY" | "FIFTEEN_MINUTES" | "HOUR" | "MINUTES_15" | "MONTH" | "WEEK" | "%future added value";
export type JiraCFODimensionInput = {
  alias?: string | null;
  name: string;
};
export type JiraCFOSortInput = {
  key?: string | null;
  order?: JiraCFOSortOrder | null;
};
export type UserSetupInsightsPerformanceSectionQuery$variables = {
  cloudId: string;
  configDimensionInput?: ReadonlyArray<JiraCFODimensionInput | null> | null;
  dimensionInput?: ReadonlyArray<JiraCFODimensionInput> | null;
  endDate: AGG$DateTime;
  granularity?: JiraCFOTimeGranularity | null;
  regionDimensionInput?: ReadonlyArray<JiraCFODimensionInput> | null;
  sortInput?: ReadonlyArray<JiraCFOSortInput | null> | null;
  startDate: AGG$DateTime;
};
export type UserSetupInsightsPerformanceSectionQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UserSetupInsightsPerformanceSection">;
};
export type UserSetupInsightsPerformanceSectionQuery = {
  response: UserSetupInsightsPerformanceSectionQuery$data;
  variables: UserSetupInsightsPerformanceSectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "configDimensionInput"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dimensionInput"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v4 = {
  "defaultValue": "HOUR",
  "kind": "LocalArgument",
  "name": "granularity"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "regionDimensionInput"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortInput"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v8 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v9 = {
  "kind": "Variable",
  "name": "dimensions",
  "variableName": "dimensionInput"
},
v10 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDate"
},
v11 = {
  "kind": "Variable",
  "name": "granularity",
  "variableName": "granularity"
},
v12 = {
  "kind": "Literal",
  "name": "isV2",
  "value": true
},
v13 = {
  "aggregation": {
    "type": "SUM"
  },
  "alias": "request_count",
  "name": "count"
},
v14 = {
  "kind": "Variable",
  "name": "sortInput",
  "variableName": "sortInput"
},
v15 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v16 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v17 = {
  "kind": "ScalarField",
  "name": "name"
},
v18 = [
  (v17/*: any*/),
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v19 = {
  "concreteType": "JiraCFODimension",
  "kind": "LinkedField",
  "name": "dimensions",
  "plural": true,
  "selections": (v18/*: any*/)
},
v20 = {
  "concreteType": "JiraCFOMetric",
  "kind": "LinkedField",
  "name": "metrics",
  "plural": true,
  "selections": (v18/*: any*/)
},
v21 = [
  (v16/*: any*/),
  {
    "concreteType": "JiraCFODataRowConnection",
    "kind": "LinkedField",
    "name": "data",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraCFODataRowEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "timestamp"
                  },
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "type": "JiraCFODefaultDataRow"
              }
            ]
          }
        ]
      }
    ]
  }
],
v22 = {
  "kind": "Literal",
  "name": "metrics",
  "value": [
    (v13/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "UserSetupInsightsPerformanceSectionQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "UserSetupInsightsPerformanceSection"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserSetupInsightsPerformanceSectionQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "performanceData",
            "args": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "kind": "Literal",
                "name": "metrics",
                "value": [
                  {
                    "aggregation": {
                      "type": "PERCENTILE",
                      "value": 0.75
                    },
                    "alias": "load_time_p75",
                    "name": "vc90"
                  },
                  (v13/*: any*/)
                ]
              },
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v21/*: any*/)
          },
          {
            "args": [
              (v8/*: any*/),
              {
                "kind": "Variable",
                "name": "dimensions",
                "variableName": "configDimensionInput"
              }
            ],
            "concreteType": "JiraCFOConfigsResult",
            "kind": "LinkedField",
            "name": "cfoConfigs",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraCFOClientSetupConfig",
                "kind": "LinkedField",
                "name": "clientSetupConfig",
                "plural": true,
                "selections": [
                  (v17/*: any*/),
                  {
                    "concreteType": "JiraCFODistribution",
                    "kind": "LinkedField",
                    "name": "distribution",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "category"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "label"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": [
              (v8/*: any*/),
              (v10/*: any*/),
              {
                "kind": "Variable",
                "name": "insightOn",
                "variableName": "dimensionInput"
              },
              (v15/*: any*/)
            ],
            "concreteType": "JiraCFOMetricInsightConnection",
            "kind": "LinkedField",
            "name": "cfoInsights",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraCFOMetricInsightEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraCFOMetricInsight",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "status"
                      },
                      {
                        "concreteType": "JiraCFOMetricInsightMetaData",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "loadTimeDiffFloat"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "userDistribution",
            "args": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v22/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v21/*: any*/)
          },
          {
            "alias": "regionBreakdown",
            "args": [
              (v8/*: any*/),
              {
                "kind": "Variable",
                "name": "dimensions",
                "variableName": "regionDimensionInput"
              },
              (v10/*: any*/),
              (v12/*: any*/),
              (v22/*: any*/),
              (v15/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              {
                "concreteType": "JiraCFODataRowConnection",
                "kind": "LinkedField",
                "name": "data",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraCFODataRowEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v19/*: any*/),
                              (v20/*: any*/)
                            ],
                            "type": "JiraCFODefaultDataRow"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3e4fb5a76528efa6596b16d5826ad1ed69896b72b44f6b7da2c1b94eab846734",
    "metadata": {},
    "name": "UserSetupInsightsPerformanceSectionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0923f496823f598e757d88e048f1a4e9";

export default node;
